module.exports = __webpack_public_path__ + "static/media/criacao-elementos-img-02.84cd6558.svg";